<template lang="html">
  <div style="height: 100%;">
    <div @click="toggleModal" class="pms-finder-card card card--center card--partner card--post">
      <div class="card-content text-secondary pr-0">
        <div class="card-header pb-0 ">
          <div v-if="badge" class="card--bedge" :class="bedgeClass(badge)">
            <img :src="badgeImageSrc" class="flagimg" :alt="badgeAltText">
          </div>
          <div v-if="city" class="card--city">
            <img src="//resources.siteminder.com/services/pms-finder/static/map-marker.svg" width="8.25px" alt="" class="map-marker"> {{ city }}
          </div>
          <figure v-if="logo" class="is-256x256 image--height-auto  image space-sm-bottom">
            <img :src="logo" :alt="title" style="width:100%;max-width:200px;margin:0 auto;">
          </figure>
          <h3 v-else>{{ title }}</h3>
        </div>
        <div class="card-body mt-0 mb-auto pb-0">
          <p class="text-secondary text-left pl-1 pr-1 mb-0 pb-0 space-bottom lead">{{ description }}</p>
        </div>
      </div>
    </div>
    <modal v-if="showModal" :name="title" :email="salesEmail" :property="property" :badge="badge" :marketoCountry="countryPicked" @close="toggleModal"></modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import VClamp from 'vue-clamp';

export default {
  name: "card",
  components: {
    Modal,
  },
  props: ["title", "type", "description", "logo", "salesEmail", "countries", "countryPicked", "city", "badge", "property"],

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    badgeImageSrc() {
      const badgeType = this.bedgeClass(this.badge);
      const lang = this.$i18n.locale;
      return `//resources.siteminder.com/services/pms-finder/static/badge-${badgeType}-2025.svg`;
    },
    badgeAltText() {
      const badgeType = this.bedgeClass(this.badge);
      return this.$t(`badge ${badgeType}`);
    },
  },

  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      this.$emit('noscoll', this.showModal);
    },

    bedgeClass(badge) {
      if (badge) {
        return badge.toString().toLowerCase().replace(/\s/g, '');
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@siteminder/chameleon-variables";
$card-hover-img: 138px;
$card-hover-img-left-pos: 138px / 3.15;

.card {
  background: white;
  transition: transform 0.15s, box-shadow 0.15s;
  max-width: 500px;
  margin: 0 auto;
  padding: 30px 0;
  &.card--split-img {
    overflow: hidden;
    position: relative;
    padding-left: 0;

    .card-media {
      position: absolute;
      padding: 0;
      top: 50%;
      left: calc(0px - #{$card-hover-img-left-pos});
      margin-top: -$card-hover-img / 2;
      width: $card-hover-img;
      height: $card-hover-img;
      transition: transform 0.15s;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .card-header,
    .card-content,
    .card-footer {
      padding-left: $card-hover-img;
    }
  }
  hr {
    padding-bottom: 10px;
  }
  .card-footer {
    color: inherit;
    font-size: 1em;
  }
  .card-body {
    word-break: break-word;
  }
  .card-header {
    padding-bottom: 5px;
    padding-top: 10px;
    // position: relative;
    .predPopTags {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &.pms-finder-card {
    cursor: pointer;
    position: relative;
    &:hover, &:focus {
      transition: transform 0.15s, box-shadow 0.15s;
      transform: translateY(-2px);
      box-shadow: 0 0 35px 2px rgba(0, 0, 0, 0.22);
    }

    .map-marker {
      vertical-align: text-bottom;
    }

    .card--bedge {
      position: absolute;
      top: 10px;
      left: -20px;
      color: #41b8ff;
      img {
        width: 60%;
      }
    }

    .card--city {
      font-size: 11px;
      position: absolute;
      color: $success_dark;
      top: 10px;
      right: 15px;

      i {
        position: absolute;
        top: 1px;
        left: -10px;
        display: inline-block;
        font-family: "Font Awesome 5 Free";
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;

        &:before {
          content: "\f3c5";
        }
      }
    }
  }

  .preferred {
    color: #573389;
  }
  .new {
    color: #c53552;
  }
}

</style>